import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const PaidTestRequests = lazy(() => import("modules/paid-test-requests/PaidTestRequests"));

export default function PaidTestRequestsPage() {
  return (
    <SuspenseWrapper>
      <PaidTestRequests />
    </SuspenseWrapper>
  );
}

